<template lang="pug">
b-tr.usage-fees-only-payment-rate-table-row
  b-td.room-name {{ roomName }}
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.noNeedNursingCare.none"
        :name="'usage-fees-only-payment-rate-' + roomId + '-no-need-nursing-care-none'"
        :maxlength="10" :class="[ { noinput: _value.noNeedNursingCare.none == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + ' 自立'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.needNursingCare.percent_10"
        :name="'usage-fees-only-payment-rate-' + roomId + '-need-nursing-care-percent-10'"
        :maxlength="10" :class="[ { noinput: _value.needNursingCare.percent_10 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + ' 1割負担'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.needNursingCare.percent_20"
        :name="'usage-fees-only-payment-rate-' + roomId + '-need-nursing-care-percent-20'"
        :maxlength="10" :class="[ { noinput: _value.needNursingCare.percent_20 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + ' 2割負担'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.needNursingCare.percent_30"
        :name="'usage-fees-only-payment-rate-' + roomId + '-need-nursing-care-percent-30'"
        :maxlength="10" :class="[ { noinput: _value.needNursingCare.percent_30 == null} ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + ' 3割負担'")
      span 円
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { NursingCare } from "@/commons/services/WaiterRecruitments";

/**
 * ### 料金シミュレーション(自立・負担割合変動タイプ) 部屋料金コンポーネント
 */
@Component({})
export default class UsageFeesOnlyPaymentRateTableRow extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: NursingCare;

  @Prop()
  roomId!: string;
  @Prop()
  roomName!: string;

  get _value(): NursingCare {
    return this.value;
  }

  set _value(newValue: NursingCare) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-only-payment-rate-table-row {
  .room-name {
    width: 140px;
  }

  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }
}
</style>
